import { SENTIMENT, Sentiment } from "@/constants";

export type GroupedSentiment = Extract<
  Sentiment,
  "positive" | "neutral" | "negative"
>;

export type SentimentKey = GroupedSentiment | "unknown";

const GROUPED_SENTIMENT: Record<Sentiment, GroupedSentiment> = {
  [SENTIMENT.VERY_POSITIVE]: SENTIMENT.POSITIVE,
  [SENTIMENT.POSITIVE]: SENTIMENT.POSITIVE,
  [SENTIMENT.NEUTRAL]: SENTIMENT.NEUTRAL,
  [SENTIMENT.NEGATIVE]: SENTIMENT.NEGATIVE,
  [SENTIMENT.VERY_NEGATIVE]: SENTIMENT.NEGATIVE,
};

export const ALL_SENTIMENTS = Object.values(SENTIMENT);

export const ALL_SENTIMENTS_BUT_NEUTRAL = [
  SENTIMENT.VERY_POSITIVE,
  SENTIMENT.POSITIVE,
  SENTIMENT.NEGATIVE,
  SENTIMENT.VERY_NEGATIVE,
];

export const SENTIMENTS_BY_GROUP: Record<GroupedSentiment, Sentiment[]> = {
  [SENTIMENT.POSITIVE]: [SENTIMENT.VERY_POSITIVE, SENTIMENT.POSITIVE],
  [SENTIMENT.NEUTRAL]: [SENTIMENT.NEUTRAL],
  [SENTIMENT.NEGATIVE]: [SENTIMENT.VERY_NEGATIVE, SENTIMENT.NEGATIVE],
};

type SentimentValues = Partial<Record<Sentiment | "unknown", Nullable<number>>>;

export function groupSentiment(sentiment: Sentiment): GroupedSentiment {
  return GROUPED_SENTIMENT[sentiment];
}

export function groupSentimentValues(
  values: SentimentValues
): Record<SentimentKey, number> {
  const grouped: Record<SentimentKey, number> = {
    [SENTIMENT.POSITIVE]: 0,
    [SENTIMENT.NEUTRAL]: 0,
    [SENTIMENT.NEGATIVE]: 0,
    unknown: values.unknown ?? 0,
  };

  for (const sentiment of Object.values(SENTIMENT)) {
    grouped[groupSentiment(sentiment)] += values[sentiment] ?? 0;
  }

  return grouped;
}
